import React from "react";
import moment from "moment";
import { findExpirationRenewalDate, formatMonto } from "../../utils";
import StatusBadge from "../global/StatusBadge";

const InvoiceRow = ({ invoice }) => {
  const renderClassPackage = () => {
    if (invoice.class_package && invoice.class_package !== null) {
      return invoice.class_package.title;
    }
  };

  const next_invoice_date = findExpirationRenewalDate(invoice.purchase);


  return (
    <tr>
      <td>#{invoice.invoice_id}</td>
      <td>#{invoice.purchase_id}</td>
      <td>{renderClassPackage()}</td>
      <td>
        {"$"}
        {formatMonto(invoice.total_payment)}
        {" MXN"}
      </td>
      <td>{moment(invoice.createdAt).format("DD MMM YYYY HH:mm")}</td>
      <td>{next_invoice_date}</td>
      <td>
        <StatusBadge {...invoice} />
      </td>
    </tr>
  );
};

export default InvoiceRow;
